export default "__VITE_ASSET__ec897d92__"